(function () {
  'use strict';
  function init(scope) {
    var nav = scope.querySelector('.product__tabs');
    if (!nav || nav.dataset.navigationReady) return;
    nav.dataset.navigationReady = 'true';
    var links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (link) { return document.getElementById(link.hash.slice(1)); }).filter(Boolean);
    function updateHeader() {
      var header = document.querySelector('.header-section');
      document.documentElement.style.setProperty('--header-height', (header ? header.getBoundingClientRect().height : 120) + 'px');
    }
    updateHeader();
    window.addEventListener('resize', updateHeader, { passive: true });
    function activate(id) {
      links.forEach(function (link) {
        var active = link.hash === '#' + id;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        updateHeader();
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        activate(target.id);
      });
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (entry) { return entry.isIntersecting; });
        if (visible.length) activate(visible[0].target.id);
      }, { rootMargin: '-25% 0px -60% 0px', threshold: 0 });
      targets.forEach(function (target) { observer.observe(target); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
